import { useState, useRef, useEffect } from 'react';

export default function CsaePolicy() {
  const [imageLoaded, setImageLoaded] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    if (imageRef.current?.complete) {
      setImageLoaded(true);
    }
  }, []);

  return (
    <div className="support-page">
      <div className={`support-left${imageLoaded ? ' is-loaded' : ''}`}>
        {!imageLoaded && <div className="support-left-shimmer" aria-hidden="true" />}
        <img
          ref={imageRef}
          src={`${process.env.PUBLIC_URL}/images/login-left.png`}
          alt=""
          onLoad={() => setImageLoaded(true)}
        />
      </div>

      <div className="support-form csae-panel">
        <div className="support-logo">
          <img src={`${process.env.PUBLIC_URL}/images/login-logo.svg`} alt="Delmont" />
        </div>

        <h2 className="support-title">Child Safety Standards (CSAE Policy)</h2>
        <p className="csae-effective">Effective Date: July 27, 2026</p>

        <div className="csae-content">
          <h3>Delmont International Child Safety Standards</h3>
          <p>
            Delmont International is committed to maintaining a safe and respectful platform for
            all users. We have a zero-tolerance policy toward Child Sexual Abuse and Exploitation
            (CSAE) and Child Sexual Abuse Material (CSAM).
          </p>
          <p>
            These standards apply to every user of the Delmont International platform.
          </p>

          <h3>Zero Tolerance Policy</h3>
          <p>The following activities are strictly prohibited:</p>
          <ul>
            <li>
              Creating, uploading, sharing, or requesting Child Sexual Abuse Material (CSAM).
            </li>
            <li>Any content that exploits, abuses, or endangers minors.</li>
            <li>
              Grooming or attempting to establish inappropriate relationships with minors.
            </li>
            <li>
              Soliciting or facilitating illegal sexual activities involving minors.
            </li>
            <li>Human trafficking or sexual exploitation of children.</li>
            <li>Any behaviour that violates applicable child protection laws.</li>
          </ul>
          <p>
            Any account found engaging in these activities will be permanently suspended.
          </p>

          <h3>Reporting</h3>
          <p>
            Users can report inappropriate content, messages, or user profiles directly within
            the application using the available reporting tools.
          </p>
          <p>Reports are reviewed promptly by our moderation team.</p>

          <h3>Enforcement</h3>
          <p>
            When we become aware of content or behaviour involving CSAE or CSAM, we may:
          </p>
          <ul>
            <li>Remove the offending content immediately.</li>
            <li>Suspend or permanently terminate the responsible account.</li>
            <li>Preserve evidence where required by law.</li>
            <li>Cooperate with law enforcement and appropriate authorities.</li>
          </ul>

          <h3>Age Requirement</h3>
          <p>
            Delmont International is intended only for adults who meet the minimum legal age
            required to use dating services in their jurisdiction.
          </p>
          <p>
            Individuals under the required age are not permitted to create accounts.
          </p>

          <h3>Compliance</h3>
          <p>
            Delmont International complies with applicable child safety laws and cooperates with
            relevant authorities regarding confirmed incidents of child exploitation and abuse.
          </p>

          <h3>Contact</h3>
          <p>For child safety concerns or reports, please contact:</p>
          <p>
            Email:{' '}
            <a href="mailto:support@delmontinternational.com">
              support@delmontinternational.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
